export interface ActivityIconOption {
  value: string;
  label: string;
}

export const DEFAULT_ACTIVITY_ICON = "bi bi-activity";

export const ACTIVITY_ICON_OPTIONS: ActivityIconOption[] = [
  { value: "bi bi-telephone", label: "Call" },
  { value: "bi bi-envelope", label: "Email" },
  { value: "bi bi-whatsapp", label: "WhatsApp" },
  { value: "bi bi-people", label: "Meeting" },
  { value: "bi bi-laptop", label: "Online Demo" },
  { value: "bi bi-browser-chrome", label: "Web Visit" },
  { value: "bi bi-check-all", label: "Task Done" },
  { value: "bi bi-journal", label: "Note" },
  { value: "bi bi-file-text", label: "Document" },
  { value: "bi bi-arrow-left-right", label: "Follow-up" },
  { value: "bi bi-telephone-outbound", label: "Outbound Call" },
  { value: "bi bi-telephone-inbound", label: "Inbound Call" },
  { value: "bi bi-telephone-x", label: "Missed Call" },
  { value: "bi bi-camera-video", label: "Video Call" },
  { value: "bi bi-person-video2", label: "1:1 Video" },
  { value: "bi bi-headset", label: "Support Call" },
  { value: "bi bi-mic", label: "Voice Note" },
  { value: "bi bi-chat-dots", label: "Chat" },
  { value: "bi bi-chat-left-text", label: "Message" },
  { value: "bi bi-send", label: "Sent" },
  { value: "bi bi-calendar-event", label: "Meeting Scheduled" },
  { value: "bi bi-calendar-check", label: "Appointment" },
  { value: "bi bi-clock-history", label: "Reminder" },
  { value: "bi bi-alarm", label: "Alarm" },
  { value: "bi bi-geo-alt", label: "Site Visit" },
  { value: "bi bi-signpost-split", label: "Referral" },
  { value: "bi bi-cash-coin", label: "Payment" },
  { value: "bi bi-receipt", label: "Invoice" },
  { value: "bi bi-clipboard-check", label: "Task" },
  { value: "bi bi-flag", label: "Flagged" },
  { value: "bi bi-trophy", label: "Deal Won" },
  { value: "bi bi-megaphone", label: "Campaign" },
];

const FALLBACK_ICON_BY_NAME: Record<string, string> = {
  call: "bi bi-telephone",
  meeting: "bi bi-people",
  email: "bi bi-envelope",
  whatsapp: "bi bi-whatsapp",
  task: "bi bi-clipboard-check",
  note: "bi bi-journal",
  visit: "bi bi-geo-alt",
  demo: "bi bi-laptop",
  chat: "bi bi-chat-dots",
  "follow up": "bi bi-arrow-left-right",
  followup: "bi bi-arrow-left-right",
};

// Heuristic guess for activity types that don't have an explicit icon set
// yet — always prefer a real `icon` value from the API over this.
export const getFallbackActivityIcon = (typeName: string): string => {
  const key = (typeName || "").trim().toLowerCase();
  return FALLBACK_ICON_BY_NAME[key] || DEFAULT_ACTIVITY_ICON;
};

export const resolveActivityIcon = (
  icon: string | null | undefined,
  typeName: string
): string => icon || getFallbackActivityIcon(typeName);
